import { IGame } from "../types/game";
import { ICanvas } from "../types/canvas";
import Palette from "../models/palette";
import Bitmap from "../bitmap";
import Color from "../models/color";
import { drawRawBlock } from "../quadra";

export interface IBonusView {
    draw(): HTMLCanvasElement
}

export default class BonusView implements IBonusView {
    screen: HTMLCanvasElement
    context: CanvasRenderingContext2D
    width: number
    height: number
    canvas: ICanvas
    palette: Palette
    blockSize: number

    constructor(screen: HTMLCanvasElement, game: IGame, width: number){
        this.canvas = game.canvas
        this.screen = screen
        this.context = screen.getContext("2d")
        if (this.context) {
            this.context.imageSmoothingEnabled = false;
            this.context.imageSmoothingQuality = "low";
        }
        this.width = this.screen.width = width
        // Height matches the board height (20 blocks)
        // block size is derived from width (1 block wide)
        this.blockSize = width;
        this.height = this.screen.height = this.blockSize * 20;
        this.palette = game.palette
    }

    public draw(): HTMLCanvasElement {
        this.context.clearRect(0, 0, this.width, this.height);
        this.drawBackground();
        if (this.canvas && this.canvas.bonus > 0) {
            this.drawPendingLines();
        }
        return this.screen;
    }
    
    private drawBackground(): void{
        let context: CanvasRenderingContext2D = this.context;
        context.fillStyle = "rgba(0,0,0,0.2)"
        context.fillRect(0, 0, this.width, this.height)
        // No individual border here, handled by GameView
    }

    private drawPendingLines(): void {
        if (!this.canvas.bon || this.canvas.bonus === 0) {
            return;
        }

        const bitmap = new Bitmap(this.context);
        let firstDone = false;

        // Limit to 20 lines visible (height of board)
        for (let i = 0; i < this.canvas.bonus && i < 20; i++) {
            const bon = this.canvas.bon[i];
            if (!bon) continue;

            // Draw from bottom up
            const y = (19 - i) * this.blockSize;
            let side = 5; // Left (1) and right (4) connections by default (vertical column)

            if (!firstDone) {
                side |= 8; // Add bottom connection for first line (visually bottom of pending stack)
                firstDone = true;
            }

            if (bon.final) {
                side |= 2; // Add top connection for final line in packet
                firstDone = false;
            }

            // Draw a single block filling the width
            const x = 0;
            const color = new Color(bon.color, this.palette);
            drawRawBlock(bitmap, x, y, side, this.blockSize, color);
        }
    }
}
